export default {"src":"/_next/static/media/advanced-search-algorithms.6892dd12.svg","height":778,"width":680,"blurWidth":0,"blurHeight":0};